module.exports = __webpack_public_path__ + "static/media/cel_at_sea_persian_gardens.32ed4064.jpg";